import styled from "styled-components";

const ButtonDay = styled.button`
    background-color: #FFFFFF;
    border: 1px solid #D4D4D4;
    border-radius: 5px;

    color: #DBDBDB;
    font-size: 19px;
`

export { ButtonDay }